/* eslint eqeqeq: "off" */
import { PatchTypeAndId, UpchargePatch, UpsertBundleUCPatchesRequest } from '@/types/bundles-upcharges.types';
import { Patches, StorePatches } from '@/types/bundles.types';

export function formatDisplayUpchargePrice(patch: { description: string; price: string } | StorePatches | undefined) {
  const regex = /^\d{1,3}(\.\d{2})?\s*-\s*\d{1,3}(\.\d{2})?$/;
  const price = patch?.price || '';
  if (regex.test(price)) {
    return `$${patch?.price}`;
  }
  return patch?.price ? `$${Number(price).toFixed(2)}` : 'None';
}

export const patchesIncludesPrice = (
  patches: { description: string; price: string }[],
  filterValue: string,
  uniqueHeader: { description: string; isLock: boolean },
) => {
  const products = patches?.find((item: any) => item?.description === uniqueHeader.description);

  const text = formatDisplayUpchargePrice(products);
  return text.toUpperCase().includes(filterValue.toUpperCase());
};

export const buildUpsertBundleUCRequest = (
  storeGroupIds: string[],
  stores: string[],
  upchargePatches: UpchargePatch[],
  dropdownValues: any,
): UpsertBundleUCPatchesRequest => {
  const DROPDOWN_PLACEHOLDER_VALUE = 'placeholder';
  const request: UpsertBundleUCPatchesRequest = { storeGroupIds, stores, patches: [] };
  Object.keys(dropdownValues).forEach((type: string) => {
    if (![undefined, DROPDOWN_PLACEHOLDER_VALUE].includes(dropdownValues[type])) {
      const patchId =
        upchargePatches
          .find((up) => up.type === type)
          ?.patchOptions.find((option) => option.price == dropdownValues[type])?.patchId || '';
      const patchTypeAndId: PatchTypeAndId = { type, patchId };
      request.patches.push(patchTypeAndId);
    }
  });
  return request;
};
